import React, { useState, useEffect } from 'react';
import './App.css';
import Desktop from './components/Desktop';
import Login from './components/Login';
import Setup from './components/Setup';
import ChatRoom from './components/ChatRoom';

function App() {
  const [user, setUser] = useState(null);
  const [targetHandle, setTargetHandle] = useState('');
  const [showLogin, setShowLogin] = useState(false);
  const [showSetup, setShowSetup] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if user is already logged in (from localStorage)
    const savedUser = localStorage.getItem('currentUser');
    const loginTime = localStorage.getItem('loginTime');

    if (savedUser && loginTime) {
      const now = Date.now();
      const timeDiff = now - parseInt(loginTime);
      const threeMinutes = 3 * 60 * 1000; // 3 minutes in milliseconds

      if (timeDiff < threeMinutes) {
        // User is still within 3-minute session
        setUser(JSON.parse(savedUser));
        setShowChat(true);
      } else {
        // Session expired, clear data
        localStorage.removeItem('currentUser');
        localStorage.removeItem('loginTime');
      }
    }

    // Mobile detection
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('currentUser', JSON.stringify(userData));
    localStorage.setItem('loginTime', Date.now().toString());
    setShowLogin(false);
    setShowChat(true);
  };

  const handleFirstTimeUser = () => {
    setShowLogin(false);
    setShowSetup(true);
  };

  const handleSetupComplete = (userData) => {
    setUser(userData);
    localStorage.setItem('currentUser', JSON.stringify(userData));
    localStorage.setItem('loginTime', Date.now().toString());
    setShowSetup(false);
    setShowChat(true);
  };

  const handleLogout = () => {
    setUser(null);
    setTargetHandle('');
    setShowChat(false);
    setShowLogin(false);
    setShowSetup(false);
    localStorage.removeItem('currentUser');
    localStorage.removeItem('loginTime');
  };

  const openGoodVibesApp = () => {
    setShowLogin(true);
  };

  const closeLogin = () => {
    setShowLogin(false);
  };

  const closeChat = () => {
    setShowChat(false);
    // Don't clear user data - keep session for 3 minutes
    setTargetHandle('');
  };

  return (
    <div className="App">
      <Desktop onOpenGoodVibes={openGoodVibesApp} />

      {showLogin && (
        <Login
          onLogin={handleLogin}
          onFirstTimeUser={handleFirstTimeUser}
          onClose={closeLogin}
        />
      )}

      {showSetup && (
        <Setup
          onSetupComplete={handleSetupComplete}
          onClose={() => setShowSetup(false)}
        />
      )}

      {showChat && user && (
        <ChatRoom
          user={user}
          targetHandle={targetHandle}
          setTargetHandle={setTargetHandle}
          onLogout={handleLogout}
          onClose={closeChat}
          isMobile={isMobile}
          onNewMessage={() => {
            // This will be handled by the Desktop component
            if (window.desktopRef && window.desktopRef.startTaskbarBlink) {
              window.desktopRef.startTaskbarBlink();
            }
          }}
        />
      )}
    </div>
  );
}

export default App;